module.exports = __webpack_public_path__ + "static/media/personal-safe.e35c8ceb.png";